<ngb-carousel
  #carousel
  [interval]="3500"
  [pauseOnHover]="true"
  [pauseOnFocus]="true"
  (slide)="onSlide($event)"
  class="carousel-wrapper"
  style="display: block; margin-top: 160px"
>
  <ng-template ngbSlide *ngFor="let item of banners; let i = index">
    <div class="carousel-caption">
      <h3 class="borda-titulo">{{ item.titulo }}</h3>
    </div>
    <a href="{{ item.urlBin }}" target="_blank" rel="nofollow noopener noreferrer">
      <div class="picsum-img-wrapper">
        <img
          class="imagem-banner"
          [src]="item.imagem"
          alt="Banner"
        />
      </div>
    </a>
  </ng-template>
</ngb-carousel>
